import React, { PropTypes } from "react";
import { intlShape } from "react-intl";

const EnumValue = (props, context) => {
  const { wantedEnum } = props;
  let enumArray = props[wantedEnum.name];
  if (!Array.isArray(props[wantedEnum.name])) {
    enumArray = props[wantedEnum.name].items;
  }
  const enumValue = enumArray.filter((obj) => {
    return obj[wantedEnum.identifier] == props.enumKey;
  })[0].localizations;
  return <span>{enumValue[context.intl.locale].name}</span>;
};

EnumValue.propTypes = {
  enum: PropTypes.object,
  enumKey: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string.isRequired,
  ]),
  wantedEnum: PropTypes.object,
};

EnumValue.contextTypes = {
  intl: intlShape,
};

export default EnumValue;



// WEBPACK FOOTER //
// ./src/utils/enums/EnumValue.js